import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { get } from "lodash";
export default {
  computed: {
    _visibilityDataContext() {
      return this;
    }
  },
  methods: {
    visibilityToggle(currentApplication, context, dataPath, options, sourcePath) {
      const application = currentApplication;
      let value = get(application, dataPath);
      if (typeof value !== "boolean" && !value) {
        const reverseAction = _findInstanceProperty(options).call(options, ({
          action,
          value
        }) => action === "show" && value === false);
        return !!reverseAction;
      }
      const {
        action
      } = _findInstanceProperty(options).call(options, option => {
        if (typeof option.value === "boolean" && typeof value === "string") {
          value = value !== "false";
        }
        return option.value === value;
      }) || {};
      const visible = action === "show";
      if (!visible && context[sourcePath] !== null) {
        context[sourcePath] = null;
      }
      return visible;
    }
  }
};